import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Col } from '../../common/interfaces';
import { Container, Padding, Margin } from '../../common/base';
import { HiwList, HiwListItem, HiwListItemCount, HiwListItemDesc } from './Styled';

import { withTranslation } from '../../common/libs/i18n';

const K_PURCHASING_STEPS = ({ t }) => [
  t('landing.how.to.purchase.step_1', 'You deposit Rupiah to our bank account'),
  t(
    'landing.how.to.purchase.step_2',
    'We mint the equivalent amount of IDRT on the Ethereum Blockchain'
  ),
  t('landing.how.to.purchase.step_3', 'We send the IDRT to your Ethereum wallet')
];

const K_REDEEM_STEPS = ({ t }) => [
  t('landing.how.to.redeem.step_1', 'You send IDRT to our redemption address'),
  t(
    'landing.how.to.redeem.step_2',
    'We burn the IDRT from the Ethereum Blockchain to reduce total circulating supply'
  ),
  t(
    'landing.how.to.redeem.step_3',
    'We transfer the equivalent amount of Rupiah to your bank account\n(minus small fees)'
  )
];

const HomeHiw = ({ t }) => (
  <Padding vertical={80}>
    <Container>
      <Grid align="center">
        <Col lg={12} text="center">
          <Margin bottom={48}>
            <h2>{t('landing.how.to.title', 'How to Purchase and Redeem IDRT')}</h2>
          </Margin>
        </Col>
        <Col lg={6} sm={12}>
          <Padding horizontal={48}>
            <img src="/static/images/hiw/hiw-purchasing.svg" alt="How It Works - Purchasing" />
          </Padding>
        </Col>
        <Col lg={6} sm={12}>
          <Margin top={40} bottom={64}>
            <h3>{t('landing.how.to.purchase.title', 'Purchase IDRT using Rupiah')}</h3>
            <HiwList>
              {K_PURCHASING_STEPS({ t }).map((item, index) => (
                <HiwListItem key={index}>
                  <HiwListItemCount>{index + 1}</HiwListItemCount>
                  <HiwListItemDesc>
                    <p>{item}</p>
                  </HiwListItemDesc>
                </HiwListItem>
              ))}
            </HiwList>
          </Margin>
          <h3>{t('landing.how.to.redeem.title', 'Redeem IDRT back to Rupiah')}</h3>
          <HiwList>
            {K_REDEEM_STEPS({ t }).map((item, index) => (
              <HiwListItem key={index}>
                <HiwListItemCount orange>{index + 1}</HiwListItemCount>
                <HiwListItemDesc>
                  <p>{item}</p>
                </HiwListItemDesc>
              </HiwListItem>
            ))}
          </HiwList>
        </Col>
      </Grid>
    </Container>
  </Padding>
);

HomeHiw.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(HomeHiw);
